import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'

import AppUtils from '../../utils/AppUtils'
import AppConstants from '../../utils/AppConstants'
import ColumnsProvider from '../../utils/ColumnsProvider'
import Page from '../../components/elements/Page'
import Header from '../../components/elements/Header'
import Table from '../../components/elements/Table'
import Confirm from '../../components/elements/Confirm'
import CreateControlPopup from '../popups/controls/CreateControlPopup'
import Grant from '../elements/Grant'

import Types from '../../actions/Types'
import ListAction from '../../actions/controls/ListAction'
import DeleteAction from '../../actions/controls/DeleteAction'
import ChangePageAction from '../../actions/app/ChangePageAction'
import ClearErrorAction from '../../actions/app/ClearErrorAction'

class ControlListPage extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      isCreate: false,
      deleteId: null
    }

    // Bind events
    this.onClickSelect = this.onClickSelect.bind(this)
    this.onClickCreate = this.onClickCreate.bind(this)
    this.onCloseCreate = this.onCloseCreate.bind(this)
    this.onClickDelete = this.onClickDelete.bind(this)
    this.onConfirmDelete = this.onConfirmDelete.bind(this)
  }

  componentDidMount() {
    this.props.fetch()
  }

  componentDidUpdate(prevProps, prevState) {
    // After a control has been deleted, refresh
    if (
      prevProps.deleteIsFetching
      &&
      !this.props.deleteIsFetching
    ) {
      this.setState({
        deleteId: null
      })
      AppUtils.setStatus(
        this.props.deleteError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.deleteError
          ? AppUtils.errorToText(this.props.deleteError)
          : 'Contrôle supprimé.'
      )
      if (!this.props.deleteError) {
        this.props.fetch()
      }
    }
  }

  onClickSelect(id) {
    return () => {
      this.props.changePage(AppConstants.PAGE.CONTROL_VIEW, id)
    }
  }

  onClickCreate() {
    this.setState({
      isCreate: true
    })
  }

  onCloseCreate(isDirty) {
    this.setState({
      isCreate: false
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickDelete(id) {
    return () => {
      this.setState({
        deleteId: id
      })
    }
  }

  onConfirmDelete(proceed) {
    if (proceed) {
      this.props.delete(this.state.deleteId)
    }
    else {
      this.setState({
        deleteId: null
      })
    }
  }

  render() {
    return (
      <React.Fragment>
        <Page direction={Page.DIRECTION.ROW}>
          <Page.Element
            flex='1 1 100%'
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Header
              style={{
                flex: '0 0 auto'
              }}
              title='Contrôles'
              right={
                <Grant role={Grant.ROLE.MANAGE}>
                  <Button
                    compact={true}
                    icon='plus'
                    content='Créer'
                    color='green'
                    onClick={this.onClickCreate}
                  />
                </Grant>
              }
            />
            <Table
              columns={[
                // Nom
                ColumnsProvider.genericName,
                // Récurrence
                ColumnsProvider.controlRecurrence,
                // Prochain
                ColumnsProvider.controlNextWithDetails,
                // Actions
                ColumnsProvider.controlActions(
                  this.onClickSelect,
                  this.onClickDelete
                )
              ]}
              data={this.props.list}
              error={this.props.error}
              isLoading={this.props.isFetching}
              emptyMessage="Il n'existe aucun contrôle pour le moment."
            />
          </Page.Element>
        </Page>
        {
          this.state.isCreate
            ? <CreateControlPopup
                onClose={this.onCloseCreate}
              />
            : null
        }
        {
          !_.isNull(this.state.deleteId)
            ? <Confirm
                header="Suppression d'un contrôle"
                body="Êtes-vous sûr de vouloir supprimer ce contrôle ?"
                confirmText='Supprimer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.deleteIsFetching}
                callback={this.onConfirmDelete}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

ControlListPage.propTypes = {
  // Properties

  // Redux State
  list: PropTypes.array,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.object,
  deleteIsFetching: PropTypes.bool.isRequired,
  deleteError: PropTypes.object,

  // Redux Actions
  fetch: PropTypes.func.isRequired,
  delete: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    list: state.entities.controls.list.data,
    isFetching: state.entities.controls.list.isFetching,
    error: state.entities.controls.list.error,
    deleteIsFetching: state.entities.controls.delete.isFetching,
    deleteError: state.entities.controls.delete.error
  }),
  (dispatch) => ({
    fetch: () => (dispatch(ListAction({}))),
    delete: (id) => (dispatch(DeleteAction({ id }))),
    clearError: () => (dispatch(ClearErrorAction(Types.CONTROLS.LIST))),
    changePage: (page, id) => (dispatch(ChangePageAction(page, { id })))
  })
)(ControlListPage)



// WEBPACK FOOTER //
// ./src/containers/pages/ControlListPage.js